import React, { useEffect, useState } from 'react';
import { Skeleton, Avatar, Tooltip } from '@mui/material';
import moment from 'moment';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import toast from 'react-hot-toast';
import CountriesSelectComponent from 'ui-component/dropdown/CountriesSelectComponent';
import ReactSelect from 'react-select';
import "/node_modules/flag-icons/css/flag-icons.min.css";

function UserFormDetailsModal({ show, id, action, handleClose, reloadList }) {
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        id: '',
        name: '',
        email: '',
        phoneCode: '971',
        phoneNumber: '',
        birthdate: '',
        address: 'FUJAIRAH',
        country: 'AE',
        password: '12345678',
        cpassword: '12345678',
        role: '',
    });

    // add dubai, fujairah and ajman to be an option in select dropdown
    const locationLists = [
        { label: 'Dubai', value: 'DUBAI' },
        { label: 'Fujairah', value: 'FUJAIRAH' },
        { label: 'Ajman', value: 'AJMAN' },
        { label: 'Ras Al-Khaimah', value: 'RAS AL KHAIMAH' },
        { label: 'Sharjah', value: 'SHARJAH' },
        { label: 'Abu Dhabi', value: 'ABU DHABI' },
        { label: 'Umm Al-Quwain', value: 'UMM AL QUWAIN' },
    ]

    const [selectedLocation, setSelectedLocation] = useState(null);

    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return decodeURIComponent(match[2]);
        return null;
    };
    useEffect(() => {
        const cookieLocation = getCookie('location');	
        if (cookieLocation) {
            setData({
                ...data,
                address: cookieLocation,
            })
            // setSelectedLocation(cookieLocation);
        }
    }, []);

    useEffect(() => { 
        setIsVisible(show);
    }, [show]);


    const getUserDetail = () => {
        setIsLoading(true);
        api.getUserDetail(id).then((res) => {
            setIsLoading(false);
            const userData = res.data;
            setData({
                id: userData?.id || '',
                name: userData?.name || '',
                email: userData?.email || '',
                phoneCode: userData?.phone_code || '971',
                phoneNumber: userData?.phone_number || '',
                birthdate: userData?.birthdate || '',
                address: userData?.address || '',
                country: userData?.country || 'AE',
                role: userData?.role || '',
            });

        });
    };

    useEffect(() => {
        if (id) {
            getUserDetail();
        }
    }, [id]);

    const handleSubmitForm = (e) => {
        if (data.name?.trim() == '') {
            toast.error("Member's Name is required.");
            return false
        }   

        const request = {
            id: data.id,
            name: data.name,
            email: data?.email,
            phone_code: data?.phoneCode,
            phone_number: data?.phoneNumber,
            gender: data?.gender,
            birthdate: data?.birthdate,
            address: data?.address,
            // address: selectedLocation,
            country: data?.country,
            password: data?.password,
            cpassword: data?.cpassword,
        }
        // console.log('formData', formData)
        // return false;
        if (action === 'EDIT') {
            api.updateUser(id, request).then(
                (res) => {
                    if (res.status) {
                        toast.success(res.message);
                        // handleClose();
                        reloadList();
                    } else {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error(err.message);
                }
            );
        } else if (action === 'CREATE') {
            api.createUser(request).then(
                (res) => {
                    if (res.status) {
                        toast.success(res.message);
                        // handleClose();
                        reloadList();
                    } else {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error(err.message);
                }
            );
        }
    }
    
    return (
        <>
            <div 
                className={`glass-effect-popup-overlay ${isVisible && 'show'}`}
                onClick={handleClose}
            >
                <div 
                    className={`glass-effect-popup-container ${isVisible ? 'glassAnimateFadeIn' : 'glassAnimateFadeOut'}`}
                    style={{ display: isVisible ? 'block' : 'none', width: '400px' }}
                    onClick={e => e.stopPropagation()}
                >
                    {/* <button className="glass-effect-popup-close-icon">&times;</button> */}
                    <button className="btn modal-close-icon text-black" onClick={handleClose}>
                        <svg height="16" width="16" viewBox="0 0 19.295 19.289">
                            <path d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                        </svg>
                    </button>
                    
                    <div className="glass-effect-popup-content">


                        <div className="row">
                            <div className="col-12 text-center fw-500" style={{ fontSize: '18px', marginBottom: '20px' }}>
                                {
                                    action === 'EDIT' ? 'Update Details' : action === 'CREATE' ? 'Add New Member' : ''
                                }
                            </div>
                        </div>
                        <div className="row mb10">
                            <div className="col-12">
                                <label>Name</label>
                                
                                <input
                                    type="text"
                                    value={data?.name}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            name: e.target.value
                                        })
                                    }}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="row mb10">
                            <div className="col-12">
                                <label>Contact #</label>
                                
                                {/* <input
                                    type="date"
                                    value={data?.birthdate}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            birthdate: e.target.value
                                        })
                                    }}
                                    className="form-control"
                                /> */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div>

                                        <CountriesSelectComponent
                                            value={data?.phoneCode}
                                            onChange={(value) => {
                                                setData((prev) => ({ ...prev, phoneCode: value?.value }))
                                                if (!data?.id) {
                                                    setData((prev) => ({ ...prev, country: value?.flagCode?.toUpperCase() }))
                                                }
                                            }}
                                            className="form-control"
                                            defaultValue={data?.phoneCode}
                                        /> 
                                    </div> 
                                    <div className="w-full">

                                        <input
                                            id="event-title"
                                            type="text"
                                            value={data?.phoneNumber}
                                            onChange={(e) => {
                                                setData({
                                                    ...data,
                                                    phoneNumber: e.target.value
                                                })
                                            }}
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row mb10">
                            <div className="col-12">
                                <label>Location</label>
                                <ReactSelect
                                    className="rs-container"
                                    classNamePrefix="rs"
                                    options={locationLists}
                                    value={locationLists?.find((item) => item?.value === data?.address)}
                                    onChange={(e) => {
                                        setData({
                                            ...data,
                                            address: e?.value
                                        })
                                    }}
                                    placeholder="No Location"
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                />
                            </div>
                        </div> */}


                    </div>

                    <div className="glass-effect-popup-actions">
                        <button
                            className="btn btn-cmpny-dtls-action btn-block flex"
                            style={{
                                justifyContent: "center",
                                marginBottom: "-10px",
                            }}
                            onClick={() => {
                                handleSubmitForm()
                            }}
                        >
                            {action === 'EDIT' ? 'Save' : action === 'CREATE' ? 'Create' : ''}
                        </button>
                        <button className="btn pm-btn-default  btn-block" onClick={handleClose}>Cancel</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserFormDetailsModal;